var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview" }, [
    _c(
      "div",
      { staticClass: "inner detail-top margin-0" },
      [
        _c("p", { staticClass: "mt10 fll hd-type-01 company-name" }, [
          _vm._v("\n      " + _vm._s(_vm.offer.companyInfo.name) + "\n    "),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "job-preview-header",
          _vm._g(
            {
              attrs: {
                title: _vm.offer.description.jobTitle,
                "is-simple": _vm.offer.description.isSimple,
                "is-original-entry-form":
                  _vm.offer.description.isOriginalEntryForm,
                "employment-status": _vm.offer.description.employmentStatus,
                "comment-highlights": _vm.getCommentHighlights(
                  _vm.targetIdMap.jobName
                ),
                "highlight-mode": _vm.highlightMode,
                "text-count-mode": _vm.offer.description.isShowMaxLength,
              },
            },
            _vm.$listeners
          )
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contents-inner clearfix mb30" },
          [
            _c(
              "job-preview-main-article",
              _vm._g(
                {
                  attrs: {
                    title: _vm.offer.description.mainTitle,
                    body: _vm.offer.description.mainBody,
                    "photo-data": _vm.offer.description.mainPhoto,
                    caption: _vm.offer.description.mainCaption,
                    "pr-codes": _vm.offer.description.prCodes,
                    "comment-highlights": _vm.getAnyCommentHighlights(
                      _vm.targetIdMap.mainArticle.prefix
                    ),
                    "highlight-mode": _vm.highlightMode,
                    "text-count-mode": _vm.offer.description.isShowMaxLength,
                  },
                },
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "pt20 mlr10" },
              [
                _c("job-preview-section-title", {
                  attrs: { title: "仕事内容" },
                }),
                _vm._v(" "),
                _c(
                  "job-preview-description",
                  _vm._g(
                    {
                      attrs: {
                        description: _vm.offer.description,
                        "comment-highlights": _vm.getAnyCommentHighlights(
                          _vm.targetIdMap.description.prefix
                        ),
                        "highlight-mode": _vm.highlightMode,
                        "text-count-mode":
                          _vm.offer.description.isShowMaxLength,
                      },
                    },
                    _vm.$listeners
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("job-preview-entry-button", {
              attrs: {
                "is-simple": _vm.offer.description.isSimple,
                "is-original-entry-form":
                  _vm.offer.description.isOriginalEntryForm,
              },
            }),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "mlr10" },
              [
                _c("job-preview-section-title", {
                  attrs: { title: "募集要項" },
                }),
                _vm._v(" "),
                _c(
                  "job-preview-requirements",
                  _vm._g(
                    {
                      attrs: {
                        requirements: _vm.offer.requirements,
                        "comment-highlights": _vm.getAnyCommentHighlights(
                          _vm.targetIdMap.requirements.prefix
                        ),
                        "highlight-mode": _vm.highlightMode,
                        "text-count-mode":
                          _vm.offer.description.isShowMaxLength,
                      },
                    },
                    _vm.$listeners
                  )
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.getFreeTopics(_vm.offer, false),
                  function (freeTopic, i) {
                    return _c(
                      "job-preview-free-topics",
                      _vm._g(
                        {
                          key: i,
                          attrs: {
                            "free-topic": freeTopic,
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.freeTopics.prefix,
                              freeTopic.index
                            ),
                            "highlight-mode": _vm.highlightMode,
                            "text-count-mode":
                              _vm.offer.description.isShowMaxLength,
                          },
                        },
                        _vm.$listeners
                      )
                    )
                  }
                ),
                _vm._v(" "),
                _c(
                  "job-preview-feature",
                  _vm._g(
                    {
                      attrs: {
                        requirements: _vm.offer.requirements,
                        "comment-highlights": _vm.getAnyCommentHighlights(
                          _vm.targetIdMap.feature.prefix
                        ),
                        "highlight-mode": _vm.highlightMode,
                        "text-count-mode":
                          _vm.offer.description.isShowMaxLength,
                      },
                    },
                    _vm.$listeners
                  )
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                !_vm.offer.description.isLightPlan &&
                _vm.offer.requirements.report.body
                  ? _c(
                      "job-preview-view-points",
                      _vm._g(
                        {
                          attrs: {
                            report: _vm.offer.requirements.report,
                            interviews: _vm.getFreeTopics(_vm.offer, true),
                            "comment-highlights":
                              _vm.commentHighlightsViewPoint,
                            "highlight-mode": _vm.highlightMode,
                            "text-count-mode":
                              _vm.offer.description.isShowMaxLength,
                          },
                        },
                        _vm.$listeners
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.realIntentions.length
                  ? _c(
                      "job-preview-real-intention",
                      _vm._g(
                        {
                          attrs: {
                            "company-name": _vm.offer.companyInfo.name,
                            "real-intentions": _vm.offer.realIntentions,
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.realIntention.prefix
                            ),
                            "highlight-mode": _vm.highlightMode,
                            "text-count-mode":
                              _vm.offer.description.isShowMaxLength,
                          },
                        },
                        _vm.$listeners
                      )
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("job-preview-entry-button", {
              attrs: {
                "is-simple": _vm.offer.description.isSimple,
                "is-original-entry-form":
                  _vm.offer.description.isOriginalEntryForm,
              },
            }),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "mlr10" },
              [
                _c("job-preview-section-title", {
                  attrs: { title: "会社概要" },
                }),
                _vm._v(" "),
                _c(
                  "job-preview-company-info",
                  _vm._g(
                    {
                      attrs: {
                        "is-light-plan": _vm.offer.description.isLightPlan,
                        "company-info": _vm.offer.companyInfo,
                        "comment-highlights": _vm.getAnyCommentHighlights(
                          _vm.targetIdMap.companyInfo.prefix
                        ),
                        "highlight-mode": _vm.highlightMode,
                        "text-count-mode":
                          _vm.offer.description.isShowMaxLength,
                      },
                    },
                    _vm.$listeners
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "pt20 mlr10" },
              [
                _c("job-preview-section-title", {
                  attrs: { title: "応募・選考" },
                }),
                _vm._v(" "),
                _c(
                  "job-preview-selection",
                  _vm._g(
                    {
                      attrs: {
                        "company-name": _vm.offer.companyInfo.name,
                        selection: _vm.offer.selection,
                        "comment-highlights": _vm.getAnyCommentHighlights(
                          _vm.targetIdMap.selection.prefix
                        ),
                        "highlight-mode": _vm.highlightMode,
                        "text-count-mode":
                          _vm.offer.description.isShowMaxLength,
                      },
                    },
                    _vm.$listeners
                  )
                ),
                _vm._v(" "),
                _vm.isShowEnvironment(_vm.offer.environment)
                  ? _c(
                      "job-preview-data-for-job",
                      _vm._g(
                        {
                          attrs: {
                            "company-name": _vm.offer.companyInfo.name,
                            environment: _vm.offer.environment,
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.environment.prefix,
                              _vm.targetIdMap.environment.job.suffix
                            ),
                            "highlight-mode": _vm.highlightMode,
                          },
                        },
                        _vm.$listeners
                      )
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("job-preview-entry-button", {
              attrs: {
                "is-simple": _vm.offer.description.isSimple,
                "is-original-entry-form":
                  _vm.offer.description.isOriginalEntryForm,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isShowEnvironment(_vm.offer.environment)
      ? _c(
          "div",
          {
            staticClass: "inner margin-0",
            attrs: { "data-test": "environmentForCompany" },
          },
          [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "inner" }, [
              _c("div", { staticClass: "plr30 company-preview" }, [
                _c(
                  "section",
                  { staticClass: "mt20 mb20" },
                  [
                    _c(
                      "job-preview-data-for-company",
                      _vm._g(
                        {
                          attrs: {
                            environment: _vm.offer.environment,
                            "comment-highlights": _vm.getAnyCommentHighlights(
                              _vm.targetIdMap.environment.prefix,
                              _vm.targetIdMap.environment.company.suffix
                            ),
                            "highlight-mode": _vm.highlightMode,
                          },
                        },
                        _vm.$listeners
                      )
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "date-set mt10 mb30 flr" }, [
      _c("li", { staticClass: "fll" }, [
        _c("p", { staticClass: "limit" }, [
          _vm._v("\n          掲載期間 yyyy/mm/dd〜yyyy/mm/dd\n        "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "fs13 detail-menu clearfix" }, [
      _c("li", { staticClass: "active" }, [
        _vm._v("\n        募集情報\n      "),
      ]),
      _vm._v(" "),
      _c("a", [_c("li", [_vm._v("フォトクリップ")])]),
      _vm._v(" "),
      _c("a", [_c("li", [_vm._v("インタビュー記事")])]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "hide-msg" }, [
        _vm._v(
          "「データをすべて見る」を押下すると、以下の内容が表示されます。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }